import { FILE_EXTENSIONS } from '@/common/constants'

export default {
  // @ts-ignore
  is3DModalOpen: ({ is3DModalOpen }) => is3DModalOpen,
  // @ts-ignore
  imageLoading: ({ imageLoading }) => imageLoading,
  // @ts-ignore
  validQuantity: ({ validQuantity }) => validQuantity,
  // @ts-ignore
  isHandledProduct: ({ isHandledProduct }) => isHandledProduct,
  // @ts-ignore
  isSendable: ({ product, validQuantity, isHandledProduct, serverError, updatingQuantityInput, validLatestQuantityInputValue }) =>
    product.has_stock && validQuantity && isHandledProduct && !serverError && !updatingQuantityInput && validLatestQuantityInputValue,
  // @ts-ignore
   hasStock: ({ product }) =>
    product.has_stock,
  // @ts-ignore
  requestError: ({ requestError }) => requestError,
  // @ts-ignore
  product: ({ product }) => product,
  // @ts-ignore
  skuImages: ({ product }) => product.sku_images,
  // @ts-ignore
  addedToEstimate: ({ product }) => product.added_to_estimate,
  // @ts-ignore
  skuImageView: ({ product }) => {
    if (!product) {
      return null
    }

    const hasSkuImages = product.sku_images.length > 0

    if (!hasSkuImages) {
      return null
    }

    return (
      // @ts-ignore
      product.sku_images.find(sku_image => Math.min(sku_image.display_order)) ||
      null
    )
  },
  // @ts-ignore
  estimate: ({ estimate }) => estimate,
  // @ts-ignore
  priceTable: ({ priceTable }) => priceTable,
  // @ts-ignore
  favoritesCount: ({ favoritesCount }) => favoritesCount,
  // @ts-ignore
  currentSKUImageView: ({ currentSKUImageView}) => currentSKUImageView,
  // @ts-ignore
  skuPrintableColors: ({ product }) =>
    product.sku_printable_cmyk_colors.concat(
      product.sku_printable_special_colors
    ),
  // @ts-ignore
  wrappingSelectedOption: ({ product, estimate }) => {
    if (
      !estimate.wrapping_selected_option.id &&
      product.wrapping_options.length === 0
    )
      return null
    return product.wrapping_options.find(
      // @ts-ignore
      option => option.id === estimate.wrapping_selected_option.id
    )
  },
  // @ts-ignore
  selectedColorPatternOption: ({ product, estimate }) => {
    if (
      !estimate.selected_color_pattern.id &&
      product.color_pattern_options.length === 0
    )
      return null
    return product.color_pattern_options.find(
      // @ts-ignore
      option => option.id === estimate.selected_color_pattern.id
    )
  },
  // @ts-ignore
  isFullColor: ({ estimate }) => {
    return estimate.selected_color_pattern?.color_pattern?.special_color_num !== 1
  },
  // @ts-ignore
  selectedEditPattern: ({ product, estimate }) => {
    if (
      !estimate.selected_edit_pattern.id &&
      product.edit_pattern_options.length === 0
    )
      return null
    return product.edit_pattern_options.find(
      // @ts-ignore
      option => option.id === estimate.selected_edit_pattern.id
    )
  },
  // @ts-ignore
  quantities: ({ estimate }) => {
    const {
      quantity,
      min_quantity,
      max_quantity,
      quantity_unit,
      units
    } = estimate
    return {
      quantity: parseInt(quantity) || 0,
      min_quantity: parseInt(min_quantity) || 0,
      max_quantity: parseInt(max_quantity) || 0,
      quantity_unit: quantity_unit || '',
      units: units || undefined
    }
  },
  // @ts-ignore
  fullRequestQueries: ({ estimate, product, isOrderPlainProduct }) => {
    const {
      quantity,
      trial,
      trial_quantity,
      first_selected_option,
      second_selected_option,
      wrapping_selected_option,
      selected_color_pattern,
      selected_edit_pattern
    } = estimate

    const queries = {
      quantity: trial ? trial_quantity : quantity,
      trial: trial,
      first_option_id: first_selected_option.id,
      second_option_id: second_selected_option.id,
      sku_wrapping_option_id: wrapping_selected_option.id,
      sku_color_pattern_id: selected_color_pattern.id
    }

    // edit_patternが1種類の場合のみサーバーサイドで判定してくれるため不要
    if (product.edit_pattern_options.length !== 1) {
      // @ts-ignore
      queries['sku_edit_pattern_id'] = selected_edit_pattern.id
    }
    if (estimate.plain_good || isOrderPlainProduct) {
      // @ts-ignore
      queries['plain_good'] = isOrderPlainProduct
    }

    return queries
  },
  // @ts-ignore
  isAIExtension({ product }): boolean {
    if (!product.restricted_file_extension) return false
    return product.restricted_file_extension
  },
  // @ts-ignore
  fileExtensionsFormat(product, getters): string {
    const fileExtensions = getters.isAIExtension ? [FILE_EXTENSIONS[0]] : FILE_EXTENSIONS
    const excludeJPGExtension = fileExtensions.filter((item: string) => item != ('jpeg'))
    const formatFileExtensions = !getters.isFullColor ? excludeJPGExtension : fileExtensions
    return formatFileExtensions.map((extension:string) => extension).join(' / ')
  },
  // @ts-ignore
  isAllowTrial: ({ product, isOrderPlainProduct, estimate}) => isOrderPlainProduct ? product.allow_trial : estimate.trial_quantity > 0,
  // @ts-ignore
  estimateQuantity: ({ estimate }) =>
    estimate.trial ? estimate.trial_quantity : estimate.quantity
}
